<template>
  <div
    class="bg-background-neutral-secondary flex cursor-pointer items-start justify-between rounded-2xl p-4"
    role="button"
    @click="toggleSelection"
  >
    <div class="flex w-full items-start space-x-3">
      <FreeCheckbox
        :checked="passenger.isSelected"
        class="pointer-events-none mt-2"
      >
        <template #content></template>
      </FreeCheckbox>

      <div class="w-full">
        <div class="flex items-start justify-between space-x-2">
          <div>
            <div
              class="text-text-neutral-primary flex flex-wrap gap-x-2 font-medium"
            >
              <p class="break-all">
                {{ passenger.lastName }}
              </p>
              <p class="break-all">
                {{ passenger.firstName }}
              </p>
            </div>
            <div class="text-text-neutral-quaternary text-xs">
              {{ t(`passengersData.passengerTypes.${passenger.type}.text`) }}
            </div>
          </div>
          <div
            v-if="isLoading"
            class="shimmer bg-background-neutral-tertiary h-5 w-14 rounded-xl"
          ></div>
          <p
            v-else
            class="whitespace-nowrap font-medium"
            :class="
              passenger.productPriceAmount === '0'
                ? 'text-text-positive-primary'
                : 'text-text-neutral-primary'
            "
          >
            <span v-price="passenger.productPriceAmount" />
          </p>
        </div>

        <div v-if="passenger.isSelected" class="mt-3 w-full">
          <FreeInput
            v-maska:[inputsMasks.date]
            :model-value="passenger.passportDate"
            type="tel"
            :placeholder="
              t('ancillaries.medicalInsurance.form.passportDatePlaceholder')
            "
            :has-error="!!errorMessage"
            @maska="updatePassportDate($event.detail.masked)"
            @click.stop
          >
            <template #errorMessage>
              <span
                v-if="errorMessage"
                class="text-text-negative-primary text-xs"
              >
                {{ errorMessage }}
              </span>
            </template>
          </FreeInput>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { aviaMasksOptions, FreeCheckbox, FreeInput } from 'freedom-shared';
  import { vMaska } from 'maska';

  const props = defineProps<{
    passenger: {
      fullName: string;
      firstName: string;
      lastName: string;
      isSelected: boolean;
      passportDate: string;
      productPriceAmount: string;
      type: string;
    };
    errorMessage?: string;
    isLoading?: boolean;
  }>();

  const emit = defineEmits<{
    onUpdateIsSelected: [boolean];
    onUpdatePassportDate: [string];
  }>();

  const inputsMasks = aviaMasksOptions;

  const { t } = useI18n();

  const toggleSelection = () => {
    emit('onUpdateIsSelected', !props.passenger.isSelected);
  };

  const updatePassportDate = (value: string) => {
    emit('onUpdatePassportDate', value);
  };
</script>
